import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import "./css/navbar.css";
import logo from "./assets/logo/logo.png";
import { useMediaQuery } from "react-responsive";
import { Menu, X, ChevronDown, ChevronRight } from "lucide-react";

export default function Navbar() {
    const navigate = useNavigate();
    const location = useLocation();
    const isDesktop = useMediaQuery({ query: "(min-width: 801px)" });
    const [menuOpen, setMenuOpen] = useState(false);
    const [entrenaOpen, setEntrenaOpen] = useState(false);
    const menuRef = useRef(null);

    const nav_items = [
        { title: "Inicio", link: "/" },
        { title: "¿Qué es la OIFem?", link: "/que-es" },
        { title: "¿Quiénes somos?", link: "/quienes-somos" },
        { title: "Histórico", link: "/historico" },
        { title: "Temario", link: '/temario'},
        { title: "Colabora", link: "/colabora" },
        { title: "Patrocinadores", link: "/patrocinadores" },
        { title: "Contacto", link: "/contacto" },
    ];

    const isParentActive = (subNav) =>
        subNav?.some((subItem) => location.pathname === subItem.link);

    const handleLinkClick = () => {
        setMenuOpen(false);
        setEntrenaOpen(false);
    };

    const toggleEntrena = () => {
        setEntrenaOpen(!entrenaOpen);
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
        if (menuOpen) {
            setEntrenaOpen(false);
        }
    };

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
                setEntrenaOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <>
            {isDesktop && (
                <div className="navbar">
                    <img src={logo} height="50px" alt="Logo" />

                    <div id="nav-links">
                        {nav_items.map((item, index) => (
                            <div key={index} className={`nav-item ${isParentActive(item.subNav) ? "active" : ""}`}>
                                {item.link ? (
                                    <NavLink
                                        to={item.link}
                                        className={({ isActive }) => (isActive ? "active" : "")}
                                        onClick={handleLinkClick}
                                    >
                                        {item.title}
                                    </NavLink>
                                ) : (
                                    <div className="dropdown">
                                        <span className="dropdown-title">{item.title}</span>
                                        {item.subNav && (
                                            <div className="dropdown-menu">
                                                {item.subNav.map((subItem, subIndex) => (
                                                    <NavLink
                                                        key={subIndex}
                                                        to={subItem.link}
                                                        className={({ isActive }) => (isActive ? "active" : "")}
                                                        onClick={handleLinkClick}
                                                    >
                                                        {subItem.title}
                                                    </NavLink>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <button onClick={() => navigate("/inscripcion")}>Inscríbete</button>
                </div>
            )}

            {!isDesktop && (
                <div>
                    <div className="navbar">
                        <button className="menu-toggle" onClick={toggleMenu}>
                            {menuOpen ? <X size={30} /> : <Menu size={30} />}
                        </button>

                        <img src={logo} height="50px" alt="Logo" />

                        <button onClick={() => navigate("/inscripcion")}>Inscríbete</button>
                    </div>

                    {menuOpen && (
                        <div className="nav-links-mobile" ref={menuRef}>
                            {nav_items.map((item, index) => (
                                <div
                                    key={index}
                                    className={`nav-item-mobile ${isParentActive(item.subNav) ? "active" : ""}`}
                                >
                                    {item.link ? (
                                        <NavLink
                                            to={item.link}
                                            className={({ isActive }) => (isActive ? "active" : "")}
                                            onClick={handleLinkClick}
                                        >
                                            {item.title}
                                        </NavLink>
                                    ) : (
                                        <div className="dropdown-mobile">
                                            <span
                                                className="dropdown-title-mobile"
                                                onClick={item.title === "Entrena" ? toggleEntrena : null}
                                            >
                                                {item.title}
                                                <span className="arrow">
                                                    {entrenaOpen ? (
                                                        <ChevronDown size={16} />
                                                    ) : (
                                                        <ChevronRight size={16} />
                                                    )}
                                                </span>
                                            </span>
                                            {item.subNav && entrenaOpen && (
                                                <div className="dropdown-menu-mobile">
                                                    {item.subNav.map((subItem, subIndex) => (
                                                        <NavLink
                                                            key={subIndex}
                                                            to={subItem.link}
                                                            className={({ isActive }) => (isActive ? "active" : "")}
                                                            onClick={handleLinkClick}
                                                        >
                                                            {subItem.title}
                                                        </NavLink>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </>
    );
}
